import "./styles/globals.css";
import { ServerStatus } from "@/components/ServerStatus";
import logo from './pertento_dark.png';

export function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="flex items-center gap-2 md:gap-4 pt-6 px-4 pb-2 md:p-8 justify-center md:justify-start">
        <img src={logo} alt="pertento logo" className="h-8 md:h-24" />
        <h1 className="text-lg md:text-4xl" style={{ fontFamily: 'Poppins, sans-serif' }}>Uptime</h1>
      </div>
      <ServerStatus randomize={0} />
    </div>
  );
}

export default App;
